import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface Team {
  id: string;
  name: string;
  logo: string;
  country: string;
  venue: string;
  city: string;
}

export const useTeams = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const { data, error } = await supabase
          .from('teams')
          .select('id, name, logo, country, venue, city')
          .eq('active', true)
          .order('name');

        if (error) {
          throw error;
        }

        setTeams(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load teams');
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  return { teams, loading, error };
};
